import React, { createContext, useState, useMemo } from "react";

export const SupervisorCurrencyContext = createContext();

function SupervisorCurrencyProvider({ children }) {
  const [currencyDetails, setCurrencyDetails] = useState([]);
  const contextValue = useMemo(
    () => ({ currencyDetails, setCurrencyDetails }),
    [currencyDetails]
  );
  return (
    <SupervisorCurrencyContext.Provider value={contextValue}>
      {children}
    </SupervisorCurrencyContext.Provider>
  );
}

export default SupervisorCurrencyProvider;
